/** Parse a composer draft into TinyFish Agent `{urls, goal}`. */

export const BROWSE_DEFAULT_GOAL = "Extract the main content as markdown.";
export const BROWSE_NO_URL = "Include a start URL (https://…)";
export const BROWSE_MAX_URLS = 8;
export const BROWSE_TOO_MANY = `At most ${BROWSE_MAX_URLS} URLs per Agent turn`;

export function browseHostOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./i, "").toLowerCase();
  } catch {
    return "";
  }
}

const URL_RE = /https?:\/\/[^\s<>"']+/gi;
const URLS_BLOCK_RE = /urls\s*:\s*\[[\s\S]*?\]/i;

export type BrowseDraft =
  | { ok: true; urls: string[]; goal: string }
  | { ok: false; error: string };

function trimTrailingPunct(url: string): string {
  return url.replace(/[.,;:!?)]+$/, "");
}

function isHttpUrl(url: string): boolean {
  try {
    const u = new URL(url);
    return (
      (u.protocol === "http:" || u.protocol === "https:") &&
      u.hostname !== "" &&
      u.username === "" &&
      u.password === ""
    );
  } catch {
    return false;
  }
}

export function parseBrowseDraft(draft: string): BrowseDraft {
  const text = draft.trim();
  const urls: string[] = [];
  const seen = new Set<string>();
  for (const raw of text.match(URL_RE) ?? []) {
    const url = trimTrailingPunct(raw);
    if (!isHttpUrl(url) || seen.has(url)) continue;
    seen.add(url);
    urls.push(url);
  }
  if (urls.length === 0) return { ok: false, error: BROWSE_NO_URL };
  if (urls.length > BROWSE_MAX_URLS) return { ok: false, error: BROWSE_TOO_MANY };
  let rest = text;
  for (const url of urls) {
    rest = rest.split(url).join(" ");
  }
  rest = rest.replace(URLS_BLOCK_RE, " ").replace(/\s+/g, " ").trim();
  return { ok: true, urls, goal: rest === "" ? BROWSE_DEFAULT_GOAL : rest };
}
